import { Trash } from 'lucide-react';
import { memo } from 'react';

import { clsx } from 'clsx';

import { ICON_SECONDARY } from '@shared/constants/colors';
import { Tooltip } from '@shared/ui/Tooltip';

import cls from './DeleteButton.module.scss';

type DeleteButtonProps = {
  onClick: () => void;
  showLabel?: boolean;
};

const TOOLTIP_DESCRIPTION = 'Удалить товар из корзины';

export const DeleteButton = memo(({ showLabel, onClick }: DeleteButtonProps) => {
  return (
    <Tooltip label={TOOLTIP_DESCRIPTION}>
      <button
        className={clsx(cls.wrap, { [cls.withLabel]: showLabel })}
        aria-label={TOOLTIP_DESCRIPTION}
        onClick={onClick}
      >
        <Trash
          size={22}
          color={ICON_SECONDARY}
        />
        {showLabel && <span className={cls.label}>Удалить</span>}
      </button>
    </Tooltip>
  );
});
